module.exports = "/img/13.32793a.webp";